import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M21 2.75a.25.25 0 0 1 .25.25v2.41a.25.25 0 0 1-.072.174l-6.427 6.544a1.75 1.75 0 0 0-.501 1.226v6.105l-4.5 1.5v-7.605c0-.458-.18-.899-.501-1.226L2.822 5.584a.25.25 0 0 1-.072-.175V3A.25.25 0 0 1 3 2.75zm-6.58 16.653.08.237z"
    }, null, -1)
  ])))
}
export default { render: render }